// src/bible.ts
import all_bible from "./es/bible.json"

export type resultBible = {
    b: string;
    c: string;
    v: string;
    content: string;
};

export class Bible {
    #bible: Object = all_bible;

    get bible(): {} {
        return this.#bible;
    }

    /**
     * Return bible book names
     */
    getAllBooks(): string[] {
        return Object.keys(this.#bible);
    }

    getBook(name: string): any {
        return (this.#bible as any)[name];
    };

    getBookVersiculums(name: string): resultBible[] {
        const book = (this.#bible as any)[name]
        return this.extractChaptersFromBook(book);
    };

    allVersiculums(): resultBible[] {
        const keys = Object.keys(all_bible);
        let result: resultBible[] = []
        for (const key of keys) {
            const book = this.getBook(key);
            const resultBibles = this.extractChaptersFromBook(book);
            result = result.concat(resultBibles);
        }
        return result
    }

    private extractChaptersFromBook(book: any): resultBible[] {
        let result: resultBible[] = []
        for (const chapter of book['chapters']) {
            var versiculumResult = chapter.verses
            if (versiculumResult) {
                var versiculos = Object.keys(versiculumResult)
                for (const versiculosKey in versiculos) {
                    if (versiculumResult[versiculosKey]) {
                        const verseItem = {
                            b: book.abreviacion,
                            c: chapter.chapter,
                            v: versiculosKey,
                            content: versiculumResult[versiculosKey]
                        }
                        result.push(verseItem)
                    }
                }
            }
        }
        return result;
    }
}
